import type { ButtonHTMLAttributes, ReactNode, Ref } from "react";
import { cx } from "../../lib/cx";
import styles from "./Chip.module.css";

export type ChipProps = {
  count?: number;
  selected?: boolean;
  children: ReactNode;
  ref?: Ref<HTMLButtonElement>;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const Chip = ({ count, selected = false, className, children, ref, ...rest }: ChipProps) => (
  <button
    ref={ref}
    type="button"
    data-selected={selected ? "true" : "false"}
    aria-pressed={selected}
    className={cx(styles.chip, className)}
    {...rest}
  >
    <span>{children}</span>
    {count !== undefined && (
      <span className={styles.count}>
        <span aria-hidden="true">·&nbsp;</span>
        <span>{count}</span>
      </span>
    )}
  </button>
);
